export default "__VITE_ASSET__Bo0V6Y4i__"